import { render, staticRenderFns } from "./TrendInformation.vue?vue&type=template&id=f8cfc860&name=trend-information&"
import script from "./TrendInformation.vue?vue&type=script&lang=js&"
export * from "./TrendInformation.vue?vue&type=script&lang=js&"
import style0 from "./TrendInformation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports